import React from "react";

import { Routes, Route, useParams } from "react-router-dom";
import DealAdvisory from "./DealAdvisory/DealAdvisory";
import Fokusthema from "./Fokusthema/Fokusthema";
import GRCAdvisory from "./GRCAdvisory/GRCAdvisory";
import CorporateAdvisory from "./CorporateAdvisory/CorporateAdvisory";
import ESGAdvisory from "./ESGAdvisory/ESGAdvisory";
import { useEffect } from "react";

export default function BeratungsfelderMenu() {
	const { type, subType } = useParams();

	return (
		<Routes>
			<Route
				path="/"
				element={<TypeComponent type={type} subType={subType} />}
			/>
		</Routes>
	);
}

function TypeComponent({ type, subType }) {
	switch (type) {
		case "deal_advisory":
			return <DealAdvisory subType={subType} />;
		case "fokusthema":
			return <Fokusthema subType={subType} />;
		case "grc":
			return <GRCAdvisory subType={subType} />;
		case "corporate_advisory":
			return <CorporateAdvisory subType={subType} />;
		case "esg_advisory":
			return <ESGAdvisory subType={subType} />;
		default:
			return null;
	}
}
